module.exports = __webpack_public_path__ + "static/media/YM57_6.e54f08b6.jpg";